'use client';

import { usePathname } from 'next/navigation';
import { type ReactNode } from 'react';

type Props = {
  aanbodSlot: Readonly<ReactNode>;
  genericSlot: Readonly<ReactNode>;
};

export function SlugNotFound({ aanbodSlot, genericSlot }: Props) {
  const pathname = usePathname();
  const segments = pathname.split('/').filter(Boolean);
  const langStripped = segments[0] === 'nl' || segments[0] === 'en' ? segments.slice(1) : segments;
  const isAanbodDetailPath = langStripped[0] === 'aanbod' && langStripped.length >= 2;

  if (isAanbodDetailPath) {
    return <>{aanbodSlot}</>;
  }

  return <>{genericSlot}</>;
}
